import React from 'react';

/**
 * プライバシーポリシーを表示するコンポーネント
 * 別タブで開かれることを想定し、戻るボタンは含みません。
 * ログイン状態にかかわらず表示可能です。
 */
const PrivacyPolicy: React.FC<{}> = () => { 
    return (
        <div className="p-4 sm:p-8 max-w-3xl mx-auto bg-white rounded-2xl shadow-xl">
            <div className="flex items-center mb-6">
                <h1 className="text-3xl font-bold text-gray-800 ml-4">プライバシーポリシー</h1>
            </div>

            <div className="prose max-w-none text-left text-gray-700 leading-relaxed">
                <p className="mb-4">
                    QuizA（以下、「本サービス」といいます。）は、利用者の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下、「個人情報保護法」といいます。）を遵守するとともに、以下のプライバシーポリシー（以下、「本ポリシー」といいます。）に従い、適切な取扱いおよび保護に努めます。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">1. 取得する情報およびその取得方法</h2>
                <p className="mb-4">本サービスにおいて、以下の情報を適切な方法で取得します。</p>
                <ul>
                    <li className="mb-2">
                        <strong>利用者から直接ご提供いただく情報:</strong> googleアカウントから提供のユーザ識別子、メールアドレス、ニックネーム、誕生日、作成したクイズデータ、回答履歴など。
                    </li>
                    <li className="mb-2">
                        <strong>サービス利用に関する情報:</strong> アクセスログ、Cookie、IPアドレス、ブラウザ情報、端末情報など。
                    </li>
                    <li className="mb-2">
                        <strong>外部サービス連携によって取得する情報:</strong> Googleアカウントログイン時に取得するGoogle ID など。
                    </li>
                </ul>

                <h2 className="text-2xl font-semibold mt-6 mb-3">2. 個人情報の利用目的</h2>
                <p className="mb-4">取得した個人情報は、以下の目的のために利用します。</p>
                <ul>
                    <li className="mb-2">本サービスの提供・運営のため</li>
                    <li className="mb-2">利用者情報、クイズデータ、回答履歴の管理のため</li>
                    <li className="mb-2">本人確認および不正利用の防止のため</li>
                    <li className="mb-2">本サービスに関するご案内、お問い合わせ等への対応のため</li>
                    <li className="mb-2">本サービスの改善、新サービスの開発のため</li>
                    <li className="mb-2">広告の表示およびサービス改善のための広告効果測定のため（将来的な導入を含む）</li>
                    <li className="mb-2">利用規約に違反する行為への対応のため</li>
                    <li className="mb-2">法令に基づく対応のため</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-6 mb-3">3. 個人情報の第三者提供</h2>
                <p className="mb-4">
                    個人情報保護法その他の法令により認められる場合を除き、利用者の同意を得ずに個人情報を第三者に提供することはありません。（法令により認められる場合とは、捜査機関からの協力要請や裁判所の命令など、法律に基づき情報開示が求められるケースを指します）
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">4. 個人情報の安全管理</h2>
                <p className="mb-4">
                    取得した個人情報については、漏洩、滅失、毀損等を防止するため、以下のような安全管理措置を講じます。
                </p>
                <ul>
                    <li className="mb-2">通信の暗号化（SSL/TLS）の実施</li>
                    <li className="mb-2">Firebaseセキュリティルールによるアクセス制御</li>
                    <li className="mb-2">管理者権限の制限と操作ログの記録</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-6 mb-3">5. 外部サービスの利用について</h2>
                <p className="mb-4">
                    本サービスでは以下の外部サービスを利用しており、これらのサービスにおいて個人情報が処理される可能性があります。
                </p>
                <ul>
                    <li className="mb-2">
                        Firebase（Google LLC）：
                        <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">https://firebase.google.com/support/privacy</a>
                    </li>
                    <li className="mb-2">
                        Google Analytics（Google LLC）：
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                    </li>
                    <li className="mb-2">
                        Googleアカウントログイン（OAuth 2.0）：
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                    </li>
                </ul>

                <h2 className="text-2xl font-semibold mt-6 mb-3">6. 未成年の利用について</h2>
                <p className="mb-4">
                    本サービスは、小学生・中学生・高校生など未成年の方を対象としています。16歳未満の利用者は、必ず保護者の同意を得た上でご利用ください。利用者が本サービスを利用した時点で、保護者の同意があったものとみなします。
                </p>
                <p className="mb-4">
                    保護者は、未成年者の個人情報の開示、訂正、削除等を求めることができます。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">7. 広告について</h2>
                <p className="mb-4">
                    本サービスでは、将来的に第三者の広告サービスを利用する可能性があります。その際、Cookie等を用いて利用者の行動履歴情報が取得されることがありますが、個人を特定する情報は含まれません。
                </p>
                <p className="mb-4">
                    広告の詳細や設定変更については、Googleの広告に関するポリシーをご参照ください：<br />
                    <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/ads</a>
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">8. 個人情報の開示、訂正、利用停止等</h2>
                <p className="mb-4">
                    ご本人または保護者からの請求があった場合は、本人確認のうえ、法令に従い適切に対応します。現在はメールによる対応を予定しています。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">9. 本ポリシーの変更</h2>
                <p className="mb-4">
                    本ポリシーは、必要に応じて改定されることがあります。改定後は、本サービス上への掲載をもって周知し、掲載時点から効力を生じるものとします。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">10. お問い合わせ窓口</h2>
                <p className="mb-4">
                    本ポリシーに関するご質問やお問合せは、以下の窓口までご連絡ください。
                </p>
                <p className="mb-4">
                    お問い合わせには順次対応しておりますが、お返事にお時間をいただく場合がございます。
                </p>
                <p>QuizA運営事務局<br />メールアドレス：quizalife@gmail.com</p>

                <p className="mt-8 text-sm text-gray-500">最終更新日：2024年8月14日</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
